import { ColDef } from '@ag-grid-community/core';
import { NormalizedColumn, ResponsiveColDef } from './types';

export function normalizeColumns<TData, TColId extends string = string>(
    columnDefs: ResponsiveColDef<TData, TColId>[],
    defaultColDef?: ColDef<TData>,
): NormalizedColumn<TData, TColId>[] {
    return columnDefs.map((colDef, index) => {
        const colId = (colDef.colId ?? (typeof colDef.field === 'string' ? colDef.field : undefined) ?? `col_${index}`) as TColId;
        const field = typeof colDef.field === 'string' ? colDef.field : undefined;

        const headerName = colDef.headerName ?? colDef.mobile?.label ?? field ?? colId;

        const sortable = colDef.sortable ?? defaultColDef?.sortable ?? true;

        const filterValue = colDef.filter ?? defaultColDef?.filter;
        const filterable = filterValue !== false && filterValue !== undefined;

        const filterType =
            typeof filterValue === 'string'
                ? filterValue
                : typeof filterValue === 'boolean'
                  ? filterValue
                  : typeof filterValue === 'function'
                    ? 'custom'
                    : undefined;

        const hidden = !!(colDef.hide || colDef.mobile?.hidden);

        return {
            colId,
            field,
            headerName,
            sortable,
            filterable,
            filterType,
            hidden,
            slot: colDef.mobile?.slot,
            order: colDef.mobile?.order,
            emphasis: colDef.mobile?.emphasis,
            renderMode: colDef.mobile?.renderMode,
            colDef,
        };
    });
}
